<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5';
    import SignInPC from '../components/pc';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            // enableAppShare({
            //     title: '快速入职！120 天掌握运维核心技能',
            //     desc: '0 基础入门进阶高级运维，专属就业服务助你斩获高薪Offer',
            //     imgUrl: 'https://s21.lgstatic.com/growth/activity/20210419/1618812499218.png'
            // });
        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>